module.exports = __webpack_public_path__ + "static/media/32.4c06573b.jpg";